// @flow
import React, {Component} from 'react';
import {View, StyleSheet, Image, Text, Animated, Platform} from 'react-native';

import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';

type Props = {
  isEsimCompatible: boolean,
  isVisible: boolean,
  isError: boolean,
};

class EsimCompatiblePanel extends Component<Props> {
  styles = getStyles();
  fadeAnim = new Animated.Value(0); // Initial opacity 0
  slideAnim = new Animated.Value(-20); // Start 20px higher

  componentDidUpdate(prevProps: Props) {
    if (this.props.isVisible && !prevProps.isVisible) {
      this.animateIn();
    } else if (!this.props.isVisible && prevProps.isVisible) {
      this.animateOut();
    }
  }

  animateIn = () => {
    Animated.parallel([
      Animated.timing(this.fadeAnim, {
        toValue: 1,
        duration: 400,
        useNativeDriver: true,
      }),
      Animated.timing(this.slideAnim, {
        toValue: 0,
        duration: 400,
        useNativeDriver: true,
      }),
    ]).start();
  };

  animateOut = () => {
    Animated.parallel([
      Animated.timing(this.fadeAnim, {
        toValue: 0,
        duration: 300,
        useNativeDriver: true,
      }),
      Animated.timing(this.slideAnim, {
        toValue: -20,
        duration: 300,
        useNativeDriver: true,
      }),
    ]).start();
  };

  showError = (isError: boolean) => {
    return isError
      ? 'SignUp.ESimCheck.eSimCompatiblePanel.phoneCompatibilityErrorText'
      : 'SignUp.ESimCheck.eSimCompatiblePanel.phoneIncompatibleText';
  };

  render() {
    const {isVisible, isEsimCompatible, isError} = this.props;

    if (!isVisible && this.fadeAnim._value === 0) return null;

    return (
      <Animated.View
        style={[
          isEsimCompatible
            ? this.styles.containerCompatible
            : this.styles.containerIncompatible,
          {
            opacity: this.fadeAnim,
            transform: [{translateY: this.slideAnim}],
          },
        ]}>
        <View style={this.styles.leftContainer}>
          <Text style={this.styles.messageTextStyle}>
            {I18n.t(
              isEsimCompatible
                ? 'SignUp.ESimCheck.eSimCompatiblePanel.phoneCompatibleText'
                : this.showError(isError),
            )}
          </Text>
        </View>
        <View style={this.styles.rightContainer}>
          <Image
            style={this.styles.imageStyle}
            source={
              isEsimCompatible ? theme.alertValidImage : theme.alertErrorImage
            }
            resizeMode="contain"
          />
        </View>
      </Animated.View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    containerCompatible: {
      flexDirection: 'row',
      position: 'absolute',
      zIndex: 9999,
      elevation: 20,
      top: 100, // Distance from the top of the screen
      alignSelf: 'center',
      width: '90%',
      borderRadius: 12,
      padding: 16,
      borderColor: theme.secondaryColor,
      backgroundColor: theme.secondaryColor,
      shadowColor: '#000',
      shadowOffset: {width: 0, height: 4},
      shadowOpacity: 0.3,
      shadowRadius: 4.65,
    },
    containerIncompatible: {
      flexDirection: 'row',
      position: 'absolute',
      zIndex: 9999,
      elevation: 20,
      top: 100,
      alignSelf: 'center',
      width: '90%',
      borderRadius: 12,
      padding: 16,
      borderColor: theme.primaryColor,
      backgroundColor: theme.primaryColor,
      shadowColor: '#000',
      shadowOffset: {width: 0, height: 4},
      shadowOpacity: 0.3,
      shadowRadius: 4.65,
    },
    leftContainer: {flex: 5, justifyContent: 'center'},
    rightContainer: {flex: 1, alignItems: 'flex-end', justifyContent: 'center'},
    messageTextStyle: {color: 'white', fontSize: 14, fontWeight: '700'},
    imageStyle: {width: 28, height: 28},
  });

export default EsimCompatiblePanel;